// GENERATED FILE - do not edit by hand.
// Source: design-system/semantic.json + primitives.json
// Regenerate: node design-system/generate.mjs

// In the dev build the teal accent is recoloured so the whole app is visually
// flagged. Production keeps the brand teal. Inlined rather than imported from
// envUtils, which is not initialised this early.
const IS_DEV_ENV = process.env.EXPO_PUBLIC_APP_ENV === "dev";
const DEV_LOGO_ACCENT = "#FF9D4B";
const BRAND_TEAL = "#54cfb2";

/** Roles from the design system. Screens should only ever use these. */
export const semanticTokens = {
  bgApp: "#030615",
  bgElevated: "#0f1220",
  bgSurface: "#1f1f23",
  bgGlass: "#ffffff1a",
  bgSubtle: "#ffffff0d",
  bgSkeleton: "#2a2a3a",
  textPrimary: "#ffffff",
  textSecondary: "#ffffff99",
  textTertiary: "#ffffff66",
  textDisabled: "#ffffff4d",
  textPlaceholder: "#71717a",
  textBrand: "#54cfb2",
  textOnLight: "#09090b",
  textOnLightSubtle: "#52525b",
  brandDefault: "#54cfb2",
  brandHover: "#3ab89c",
  brandDark: "#1b9175",
  brandSubtle: "#e8faf7",
  brandGlass: "#54cfb21f",
  borderSubtle: "#ffffff1a",
  borderDefault: "#ffffff33",
  borderStrong: "#ffffff66",
  borderActive: "#ffffff",
  borderNeutral: "#71717a",
  borderLight: "#e4e4e7",
  borderAccent: "#7f00ff",
  borderErrorAccent: "#f3acff",
  statusErrorDefault: "#ef4444",
  statusErrorSubtle: "#fef2f2",
  statusErrorMuted: "#fca5a5",
  statusSuccessDefault: "#22c55e",
  statusSuccessSubtle: "#f0fdf4",
  statusSuccessMuted: "#86efac",
  statusWarningDefault: "#f59e0b",
  statusWarningSubtle: "#fffbeb",
  statusInfoDefault: "#3b82f6",
  statusInfoSubtle: "#eff6ff",
  stateHover: "#ffffff0d",
  stateSelected: "#54cfb21f",
  stateFocused: "#54cfb233",
  stateDisabled: "#ffffff4d",
  overlayLight: "#0000004d",
  overlayMedium: "#0000008c",
  overlayHeavy: "#000000cc",
  overlayNavy: "#030615d9",
  accentLink: "#93c5fd",
  accentPurple: "#ab42bc",
  accentPurpleDark: "#521bd3",
  accentPurpleLight: "#bca3ff",
  accentPurpleText: "#f3acff",
  surfaceLight: "#fafafa",
  surfaceLightBorder: "#e4e4e7",
  surfaceLightButtonSecondary: "#a1a1aa",
  indicatorNormal: "#4caf50",
  indicatorHigh: "#ffd000",
  indicatorVeryHigh: "#ff7a00",
  indicatorCritical: "#ef4444",
} as const;

/**
 * Colours the app still needs that the design system has not given a role to:
 * gradients, article overlays, risk-card backgrounds, the remaining white and
 * black alpha steps, and the placeholder screens. Each one is a question for
 * the designer, not a decision to make here - so they are kept verbatim and
 * kept separate, so it stays obvious what is and is not covered.
 */
export const unmappedTokens = {
  appBackgroundClear: "rgba(3, 6, 21, 0)",
  bgSubtleClear: "rgba(15, 18, 32, 0)",
  secondaryText: "rgba(255, 255, 255, 0.5)",
  textOpaque: "rgba(255, 255, 255, 0.8)",
  searchInputText: "rgba(255, 255, 255, 0.8)",
  separatorDarker: "rgba(255, 255, 255, 0.15)",
  purpleDarkTransparent: "rgba(44, 30, 58, 0.5)",
  outOfRangeBg: "rgba(239, 68, 68, 0.08)",
  indicatorInformational: "#8B5CF6",
  resultCommentAccent: "#7200EC",
  riskHighBg: "#311A2C",
  riskMediumBg: "#3C251A",
  riskLowBg: "#172B17",
  riskMediumFg: "#FF9E72",
  riskUnknownIconBg: "#DAE2F3",
  calloutNegative: "#CF6679",
  articleHeaderOverlay: "rgba(22, 14, 29, 0.3)",
  articleGradientTop: "rgba(22, 14, 29, 0.2)",
  articleGradientBottom: "#000000",
  gradientCyan: "#0CFFFF",
  gradientCyanDark: "#011C1C",
  gradientPurple: "#D09AFF",
  gradientArticleBase: "#160E1D",
  lightRowSelectedBg: "rgba(127, 0, 255, 0.1)",
  lightHairline: "rgba(0, 0, 0, 0.1)",
  lightUnitText: "#656565",
  lightSurfaceClear: "rgba(255, 255, 255, 0)",
  feedbackTextSecondary: "#E0E0E0",
  chartBarGreen: "#42DB80",
  educationCardBg: "rgba(217, 217, 217, 0.11)",
  white14: "rgba(255, 255, 255, 0.14)",
  white25: "rgba(255, 255, 255, 0.25)",
  white40: "rgba(255, 255, 255, 0.4)",
  white90: "rgba(255, 255, 255, 0.9)",
  placeholderCardBorder: "#555555",
} as const;

export const colorTokens: Record<string, string> = Object.fromEntries(
  Object.entries({ ...semanticTokens, ...unmappedTokens }).map(([name, value]) => [
    name,
    IS_DEV_ENV && value.toLowerCase() === BRAND_TEAL ? DEV_LOGO_ACCENT : value,
  ]),
);
